/*
 * @Author: Yolo
 * @Date: 2024-07-02 09:16:14
 * @Last Modified by: Yolo
 * @Last Modified time: 2024-07-02 09:21:34
 * @Desc 全球时区
 */
import L from 'leaflet'
import { CommUtils } from '@map-sdk/sdk/utils/CommUtils'
import { AreaViewBase } from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
import { timezones } from '@map-sdk/sdk/plugins/AreaView/layer/TimeZoneSymbolData'
import type { AreaViewBaseOptions } from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'
interface TimeZoneProperties {
  zone: number
}
type TimeZoneFeature = GeoJSON.Feature<GeoJSON.Polygon, TimeZoneProperties>

class TimeZoneSymbol extends AreaViewBase {
  constructor(map: MyMap, options?: Partial<AreaViewBaseOptions>) {
    super(map, { ...(options || {}), minzoom: 3 })
    this._data = timezones
  }
  _show(): this {
    if (!this._data) {
      console.error('区域图形展示，请求无数据！')
      return this
    }

    let color = '#666'
    if (this._map.mapType === 'MT_SATELLITE') {
      color = '#fff'
    }

    const commonOptions: L.GeoJSONOptions = {
      style: {
        color,
        weight: 2,
        fillColor: color,
        fillOpacity: 0.2,
      },
      onEachFeature: (feature: TimeZoneFeature, layer: L.GeoJSON) => {
        const popupContent = () => {
          let html = '<div class="box"><div class="title">'
          let addStr = '+'
          if (feature.properties.zone < 0) {
            addStr = '-'
          }
          html += `UTC(${addStr}${Math.abs(feature.properties.zone)})`
          html += `<span>${CommUtils.dataFormat(
            CommUtils.getTimeByTimeZone(feature.properties.zone),
            'hh:mm'
          )}</span></div></div>`
          return html
        }

        layer.bindPopup(popupContent, {
          className: 'time-popup',
          closeButton: false,
        })

        layer.on('mousemove', () => {
          layer.setStyle({
            fillColor: '#ff4648',
            fillOpacity: 0.5,
          })
          layer.openPopup()
        })

        layer.on('mouseout', () => {
          layer.setStyle(
            commonOptions.style || {
              fillColor: color,
              fillOpacity: 0.2,
            }
          )
          layer.closePopup()
        })
      },
    }

    this._areaLayers.push(L.geoJSON(this._data, commonOptions).addTo(this._map))

    return this
  }
}

export function timeZoneSymbol(
  map: MyMap,
  options?: Partial<AreaViewBaseOptions>
): TimeZoneSymbol {
  return new TimeZoneSymbol(map, options)
}
